import React, {Component} from 'react';
import {ModalBody, ModalFooter} from 'reactstrap';
import {
    CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL,
    CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT
} from "./GoalConfiguration";
import {RADIO_BUTTON_NOT_SELECTED, RADIO_BUTTON_SELECTED, RadioButton} from "../../elements/RadioButton";
import AdAccountsItems from "../../elements/AdAccountsItems";
import {CHANNEL_INFO_BY_CHANNEL} from "../../channels/channels";
import {AccountActionsConfiguration} from "../accounts/AccountActionsConfiguration";
import { withTranslation } from 'react-i18next';


class EditMetricConversionConfigurationFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            actionConfigByBuccId: this._buildInitialActionConfigByBuccId(props),
            conversionType: this.props.conversionType
        };

        this.handleConversionTypeChange = this.handleConversionTypeChange.bind(this)
        this.handleAdAccountActionsChange = this.handleAdAccountActionsChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.footerButton = this.footerButton.bind(this);
    }

    _buildInitialActionConfigByBuccId(props) {
        const incoming = props.actionConfigByBuccId !== undefined && props.actionConfigByBuccId !== null ? props.actionConfigByBuccId : {};
        const merged = {};
        if (props.adAccountsActionData) {
            props.adAccountsActionData.getAdAccountsData().forEach(adAccountData => {
                const buccId = adAccountData["bucc_id"];
                const channel = adAccountData["channel"];
                const channelHasAllPrimary = CHANNEL_INFO_BY_CHANNEL[channel] && CHANNEL_INFO_BY_CHANNEL[channel]["hasIncludeAllConversionsSetting"] === true;
                if (incoming[buccId] !== undefined) {
                    merged[buccId] = {
                        action_ids: incoming[buccId].action_ids || [],
                        use_ad_account_all_primary_conversions: incoming[buccId].use_ad_account_all_primary_conversions === true,
                    };
                } else {
                    // Default por canal: GA4-like → "Todas las conversiones primarias"; resto → ningún evento.
                    merged[buccId] = {
                        action_ids: [],
                        use_ad_account_all_primary_conversions: channelHasAllPrimary,
                    };
                }
            });
        }
        return merged;
    }

    handleConversionTypeChange(conversionType) {
        this.setState({
            conversionType: conversionType
        });
    }

    handleAdAccountActionsChange(buccId, actionsIds, useAllPrimaryConversions){
        const actionConfigByBuccId = {...this.state.actionConfigByBuccId};
        actionConfigByBuccId[buccId] = {
            action_ids: actionsIds,
            use_ad_account_all_primary_conversions: useAllPrimaryConversions === true,
        };
        this.setState({
            actionConfigByBuccId: actionConfigByBuccId
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        event.stopPropagation();
        this.props.afterSuccessfulEdited(this.state.conversionType, this.state.actionConfigByBuccId)
    }

    footerButton() {
        const { t } = this.props;
        return <input type="submit" value={t('client.select_button')} className="btn -submit"/>
    }

    renderAdAccountsItems() {
        if(this.state.conversionType !== CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT)
            return;

        const adAccountsSelectedItemsData = this.props.adAccountsActionData.getAdAccountsSelectedItemsData();
        return <AdAccountsItems adAccountsSelectedItemsData={adAccountsSelectedItemsData}/>
    }

    getActionConfigOfBucc(buccId) {
        const config = this.state.actionConfigByBuccId[buccId];
        if (config === undefined || config === null) {
            return { action_ids: [], use_ad_account_all_primary_conversions: false };
        }
        return config;
    }

    renderAdAccountsItemsToSelect() {
        if(this.state.conversionType !== CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL)
            return;

        const result = []
        this.props.adAccountsActionData.getAdAccountsData().forEach(adAccountData => {
            const buccId = adAccountData["bucc_id"];
            const channel = adAccountData["channel"];
            const channelHasAllPrimary = CHANNEL_INFO_BY_CHANNEL[channel]?.hasIncludeAllConversionsSetting;
            const config = this.getActionConfigOfBucc(buccId);
            result.push(<div className={"mt-4 ad_account-actions-selector"}><AccountActionsConfiguration
                showTextWithUserIndication={false}
                showAdAccountHeader={true}
                channel={channel}
                accountId={adAccountData["ad_account_account_id"]}
                name={adAccountData["ad_account_name"]}
                selectedActions={config.action_ids}
                allActions={this.props.adAccountsActionData.getAllActionsOfCampaignsConfiguration(buccId)}
                onChange={(actionsIds, useAllPrimaryConversions) => {this.handleAdAccountActionsChange(buccId, actionsIds, useAllPrimaryConversions); }}
                hasIncludeAllConversionsSetting={channelHasAllPrimary}
                useAllPrimaryConversions={channelHasAllPrimary ? config.use_ad_account_all_primary_conversions : undefined}
            /></div>);
        });

        return result;
    }

    render() {

        const typeBusinessUnitActionRadioButtonStatus = this.state.conversionType === CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT ? RADIO_BUTTON_SELECTED : RADIO_BUTTON_NOT_SELECTED;
        const typeSelectActionsRadioButtonStatus = this.state.conversionType === CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL ? RADIO_BUTTON_SELECTED : RADIO_BUTTON_NOT_SELECTED;

        return (
            <form onSubmit={this.handleSubmit}>
                <ModalBody>
                    <div className="modal-section">
                        <div className="form-row">
                            <div className="col-12 d-flex align-items-start">
                                <RadioButton status={typeBusinessUnitActionRadioButtonStatus} onActivation={() => {
                                    this.handleConversionTypeChange(CONVERSION_TYPE_USE_ACTIONS_FROM_BUSINESS_UNIT);
                                }}/>
                                <div className="ml-2 mt-2">
                                    {this.props.t('edit_metric_conversion_form.use_same_events')}
                                    {this.renderAdAccountsItems()}
                                </div>
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-12 d-flex align-items-start">
                                <RadioButton status={typeSelectActionsRadioButtonStatus} onActivation={() => {
                                    this.handleConversionTypeChange(CONVERSION_TYPE_ACTIONS_SELECTED_FOR_GOAL);
                                }}/>
                                <div className="ml-2 mt-2 multiple-ad_accounts-actions-selector">
                                    {this.props.t('edit_metric_conversion_form.select_specific_events')}
                                    {this.renderAdAccountsItemsToSelect()}
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    {this.footerButton()}
                </ModalFooter>
            </form>
        )
    }
}

export const EditMetricConversionConfigurationForm = withTranslation()(EditMetricConversionConfigurationFormComponent);
